var StatusProtocolo = /** @class */ (function () {
    function StatusProtocolo(id, titulo) {
        this.id = id;
        this.titulo = titulo;
    }
    return StatusProtocolo;
}());
export { StatusProtocolo };
